// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';
import 'vant/lib/index.css';
import '@/assets/styles/public.less'
import '@/assets/styles/vantInit.less'
import '@/assets/iconfont/iconfont.css'
Vue.config.productionTip = false
Vue.use(Vant);
import request from '@/utils/request';
Vue.prototype.$request = request;
import global from '@/utils/global'
Vue.prototype.globalFn = global;
import api from '@/api/index.js'
Vue.prototype.$api = api;
import storage from '@/utils/storage.js';
Vue.prototype.storage = storage;
import store from "@/store"
import "./directive/index";
import '@/assets/iconfont/iconfont.js';
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app")